import { render, staticRenderFns } from "./DocumentationLink.vue?vue&type=template&id=c6753a9a&scoped=true"
import script from "./DocumentationLink.vue?vue&type=script&lang=ts"
export * from "./DocumentationLink.vue?vue&type=script&lang=ts"
import style0 from "./DocumentationLink.vue?vue&type=style&index=0&id=c6753a9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6753a9a",
  null
  
)

export default component.exports